interface Details {
  name: string;
  email: string;
}

export class EmailRequest {
  private readonly verifiedSender: Details = {
    email: 'brachu92@o2.pl',
    name: 'Brasiu',
  };

  private antiquoholicsEmail: string;

  private sender: Details;

  private readonly jobType: string;

  private readonly message: string;

  constructor(sender: Details, antiquoholicsEmail: string, jobType: string, message: string) {
    this.sender = sender;
    this.antiquoholicsEmail = antiquoholicsEmail;
    this.jobType = jobType;
    this.message = message;
  }

  getEmailRequest() {
    return {
      to: this.antiquoholicsEmail, // Change to your recipient
      subject: this.getTitle(),
      text: this.getTextMessage(),
      html: this.getHtmlMessage(),
    };
  }

  private getTitle() {
    return `Wiadomość od ${this.sender.email}`;
  }

  private getTextMessage() {
    return `
    Masz nową wiadomość ze strony internetowej antiquoholics

    Nadawca: ${this.sender.email}
    Adres email: ${this.sender.email}

    ${this.message}
    `;
  }

  private getHtmlMessage() {
    return `<div>
    <h2>Wiadomość ze strony internetowej antiquoholics</h2>
    <h4>Nadawca: </h4><p>${this.sender.email}</p>
    <h4>Adres email: </h4><a href="mailto:${this.sender.email}">${this.sender.email}</a>
    <p>${this.message}</p>
    </div>`;
  }
}
